import React, { useEffect, useState } from "react";
import { SETTING } from "../../../utils/constants/apiUrl";
import { get, put } from "../../../server";
import { loggedInUser } from "../../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../Loader";
import showToast from "../../../helpers/showToast";
import { Button, Card } from "react-bootstrap";
const Notification = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  const [notifications, setNotifications] = useState({
    user_id: "",
    contact_email: "",
    send_push: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.currentTarget.checked;
    setNotifications({ ...notifications, [name]: value });
  };

  const loadNotifications = async () => {
    setLoading(true);

    let { status, message, data } = await get(
      `${SETTING}/userNotification`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setNotifications(data);
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    let { status, message, data } = await put(
      `${SETTING}/userNotification`,
      notifications,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);
    setLoading(false);
  };

  useEffect(() => {
    loadNotifications();
  }, []);
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Card className="notificationWrapper bioDataWrapper">
        <Card.Body>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="switchWrapper mb-3">
                <h6>Receive Notifications</h6>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    name="send_push"
                    checked={notifications.send_push}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <p className="info">
                Opt in to receive push notifications from the administrator on
                this account.
              </p>
            </div>
          </div>
          <Button
            variant="primary"
            type="button"
            className="mt-4"
            onClick={handleSubmit}
          >
            Update Notification
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default Notification;
